<!--
  Created 21.06.2023
  Entity info component
  ...created quickly with the help of ChatGPT 4.0...
-->
<template>
  <div class="flex justify-center items-center">
    <button
      class="px-4 py-2 mr-8 rounded-lg shadow-sm
        border border-gray-300 hover:border-gray-400 bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-gray-700
        disabled:opacity-50 disabled:cursor-not-allowed"
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)">
      Previous
    </button>

    <template v-for="page in pages">
      <button
        class="px-4 py-2 mx-1 rounded-lg shadow-sm w-12
          border border-gray-300 hover:border-gray-400 bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-gray-700"
        :class="{ 'border-gray-400 bg-gray-300 font-bold ': page === currentPage }"
        @click="changePage(page)">
        {{ page }}
      </button>
    </template>

    <button
      class="px-4 py-2 ml-8 rounded-lg shadow-sm
        border border-gray-300 hover:border-gray-400 bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-gray-700
        disabled:opacity-50 disabled:cursor-not-allowed"
      :disabled="currentPage === totalPages"
      @click="changePage(currentPage + 1)">
      Next
    </button>
  </div>
</template>

<script setup>
import {
  ref, computed, watchEffect,
} from 'vue';

const props = defineProps({
  totalItems: {
    type: Number,
    required: true,
  },
  itemsPerPage: {
    type: Number,
    default: 10,
  },
});

const emit = defineEmits(['page-changed']);

const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage));

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    emit('page-changed', page);
  }
};

const pages = computed(() => {
  let min = currentPage.value - 2;
  if (min < 1) {
    min = 1;
  }

  let max = min + 4;
  if (max > totalPages.value) {
    max = totalPages.value;
    min = Math.max(1, totalPages.value - 4);
  }

  const range = [];
  // eslint-disable-next-line no-plusplus
  for (let i = min; i <= max; i++) {
    range.push(i);
  }

  return range;
});
</script>
